<template>
  <router-view />
</template>

<script>
import { createMetaMixin } from 'quasar'

export default {
  name: 'App',

  mixins: [
    createMetaMixin({
      titleTemplate: title => `${title} - Comercial`
    })
  ]
}
</script>
